<template>
  <div class="insidePageLeft">
    <ul>
      <li v-for="(item, index) in leftli" :key="index"
          :class="{'active':ind === index}"
          @click="changeBgc(index)">
      <router-link  to="/major">
        {{item}}
      </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'InsidePageLeft',
  data: function () {
    return {
      leftli: ['高职高专', '成人教育', '专升本'],
      ind: 0
    }
  },
  methods: {
    changeBgc: function (index) {
      this.ind = index
    }
  },
  computed: {
    ...mapState(['city'])
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  .insidePageLeft{
    width:100%;
    font-size:15px;
    ul{
      height:60px;
    }
    li{
      border-right:1px solid #e8e8e8;
      padding:0 40px;
      height:60px;
      line-height:60px;
      cursor:pointer
      float:left;
    }
    h1{
      height:80px;
      line-height 80px;
      font-size:30px;
      font-weight bold;
      color:#fff;
      background:$bgColor
    }
      li.active{
      background:$bgColor;
      color:#fff;
        a{
          color:#fff;
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/common/components/InsidePageLeft.vue